import { Icon, type IconProps } from "@chakra-ui/icon";

function FolderIcon(props: IconProps) {
	return (
		<Icon
			viewBox="0 0 16 17"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				opacity="0.12"
				d="M1.33331 4.63333C1.33331 3.8866 1.33331 3.51323 1.47864 3.22801C1.60647 2.97713 1.81044 2.77316 2.06133 2.64532C2.34654 2.5 2.71991 2.5 3.46665 2.5H6.01484C6.49345 2.5 6.73276 2.5 6.94403 2.57287C7.13086 2.63732 7.30103 2.74249 7.44223 2.88078C7.60189 3.03715 7.70891 3.2512 7.92295 3.67928L8.66665 5.16667H1.33331V4.63333Z"
				fill="currentColor"
			/>
			<path
				d="M8.66665 5.16667L7.92295 3.67928C7.70892 3.2512 7.60189 3.03715 7.44223 2.88078C7.30103 2.74249 7.13086 2.63732 6.94403 2.57287C6.73276 2.5 6.49345 2.5 6.01484 2.5H3.46665C2.71991 2.5 2.34654 2.5 2.06133 2.64532C1.81044 2.77316 1.60647 2.97713 1.47864 3.22801C1.33331 3.51323 1.33331 3.8866 1.33331 4.63333V5.16667M1.33331 5.16667H11.4666C12.5868 5.16667 13.1468 5.16667 13.5746 5.38465C13.951 5.5764 14.2569 5.88236 14.4487 6.25869C14.6666 6.68651 14.6666 7.24656 14.6666 8.36667V11.3C14.6666 12.4201 14.6666 12.9802 14.4487 13.408C14.2569 13.7843 13.951 14.0903 13.5746 14.282C13.1468 14.5 12.5868 14.5 11.4666 14.5H4.53331C3.41321 14.5 2.85316 14.5 2.42533 14.282C2.04901 14.0903 1.74305 13.7843 1.5513 13.408C1.33331 12.9802 1.33331 12.4201 1.33331 11.3V5.16667Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Icon>
	);
}

export default FolderIcon;
